import { Grid, Typography } from '@mui/material';
import { Edit } from '@tcl-argon-icons/icons';
import { AccentPalette } from '@tcl-boron-colors/colors';
import { createUseStyles } from 'react-jss';
import { FC } from 'react';
import { Button } from '@tcl-boron-prefabs/button';
import usePortalContext from '../context/usePortalContext';

const useStyles = createUseStyles({
  container: {
    color: AccentPalette[100],
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

const EditButton: FC = () => {
  const { setIsFormEditOpen } = usePortalContext();
  const classes = useStyles();
  const edit = () => {
    setIsFormEditOpen(true);
  };

  return (
    <Button buttonType="tertiary" onClick={edit} small={true} ariaLabel="Edit">
      <Grid className={classes.container}>
        <Edit height={16} width={16} />
        <Typography variant="button">Edit</Typography>
      </Grid>
    </Button>
  );
};

export default EditButton;
